import { CalendarCheck, Phone } from "lucide-react";
import { triggerBookingPopup } from "./Header";

const PHONE_NUMBER = "8050731754";

const BrandServiceCta = ({ title, text }) => {
  return (
    <div className="brand-action-cta">
      {title ? <h3>{title}</h3> : null}
      {text ? <p>{text}</p> : null}

      <div className="brand-action-buttons">
        <button
          type="button"
          className="brand-action-btn"
          onClick={triggerBookingPopup}
        >
          <CalendarCheck size={26} strokeWidth={2.4} />
          <span>Book Service</span>
        </button>

        <a href={`tel:${PHONE_NUMBER}`} className="brand-action-btn">
          <Phone size={26} strokeWidth={2.4} />
          <span>Call Now: {PHONE_NUMBER}</span>
        </a>
      </div>
    </div>
  );
};

export default BrandServiceCta;
